/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * subscribe
 * OpenAPI spec version: 0.1.0
 */
import type {
  CreateCheckoutSessionCheckoutPost200,
  CreateCustomerCustomerGet200,
  GetActiveSubscriptionsSubscriptionsGet200Item,
  HTTPValidationError,
  HealthHealthGet200,
  ProcessStripeWebhookWebhooksStripePost200
} from '../models';


export type healthHealthGetResponse200 = {
  data: HealthHealthGet200
  status: 200
}

export type healthHealthGetResponseSuccess = (healthHealthGetResponse200) & {
  headers: Headers;
};
;

export type healthHealthGetResponse = (healthHealthGetResponseSuccess)

export const getHealthHealthGetUrl = () => {




  return `https://subscribe-staging.api.powertrip.earth/health`
}

/**
 * @summary Health
 */
export const healthHealthGet = async ( options?: RequestInit): Promise<healthHealthGetResponse> => {

  const res = await fetch(getHealthHealthGetUrl(),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: healthHealthGetResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as healthHealthGetResponse
}


export type processStripeWebhookWebhooksStripePostResponse200 = {
  data: ProcessStripeWebhookWebhooksStripePost200
  status: 200
}

export type processStripeWebhookWebhooksStripePostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type processStripeWebhookWebhooksStripePostResponseSuccess = (processStripeWebhookWebhooksStripePostResponse200) & {
  headers: Headers;
};
export type processStripeWebhookWebhooksStripePostResponseError = (processStripeWebhookWebhooksStripePostResponse422) & {
  headers: Headers;
};

export type processStripeWebhookWebhooksStripePostResponse = (processStripeWebhookWebhooksStripePostResponseSuccess | processStripeWebhookWebhooksStripePostResponseError)

export const getProcessStripeWebhookWebhooksStripePostUrl = () => {




  return `https://subscribe-staging.api.powertrip.earth/webhooks/stripe`
}

/**
 * @summary Process Stripe Webhook
 */
export const processStripeWebhookWebhooksStripePost = async ( options?: RequestInit): Promise<processStripeWebhookWebhooksStripePostResponse> => {

  const res = await fetch(getProcessStripeWebhookWebhooksStripePostUrl(),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: processStripeWebhookWebhooksStripePostResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as processStripeWebhookWebhooksStripePostResponse
}


export type getActiveSubscriptionsSubscriptionsGetResponse200 = {
  data: GetActiveSubscriptionsSubscriptionsGet200Item[]
  status: 200
}

export type getActiveSubscriptionsSubscriptionsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getActiveSubscriptionsSubscriptionsGetResponseSuccess = (getActiveSubscriptionsSubscriptionsGetResponse200) & {
  headers: Headers;
};
export type getActiveSubscriptionsSubscriptionsGetResponseError = (getActiveSubscriptionsSubscriptionsGetResponse422) & {
  headers: Headers;
};

export type getActiveSubscriptionsSubscriptionsGetResponse = (getActiveSubscriptionsSubscriptionsGetResponseSuccess | getActiveSubscriptionsSubscriptionsGetResponseError)

export const getGetActiveSubscriptionsSubscriptionsGetUrl = () => {




  return `https://subscribe-staging.api.powertrip.earth/subscriptions`
}

/**
 * @summary Get Active Subscriptions
 */
export const getActiveSubscriptionsSubscriptionsGet = async ( options?: RequestInit): Promise<getActiveSubscriptionsSubscriptionsGetResponse> => {

  const res = await fetch(getGetActiveSubscriptionsSubscriptionsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getActiveSubscriptionsSubscriptionsGetResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getActiveSubscriptionsSubscriptionsGetResponse
}


export type createCustomerCustomerGetResponse200 = {
  data: CreateCustomerCustomerGet200
  status: 200
}

export type createCustomerCustomerGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createCustomerCustomerGetResponseSuccess = (createCustomerCustomerGetResponse200) & {
  headers: Headers;
};
export type createCustomerCustomerGetResponseError = (createCustomerCustomerGetResponse422) & {
  headers: Headers;
};

export type createCustomerCustomerGetResponse = (createCustomerCustomerGetResponseSuccess | createCustomerCustomerGetResponseError)

export const getCreateCustomerCustomerGetUrl = () => {




  return `https://subscribe-staging.api.powertrip.earth/customer`
}

/**
 * @summary Create Customer
 */
export const createCustomerCustomerGet = async ( options?: RequestInit): Promise<createCustomerCustomerGetResponse> => {

  const res = await fetch(getCreateCustomerCustomerGetUrl(),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createCustomerCustomerGetResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createCustomerCustomerGetResponse
}


export type createCheckoutSessionCheckoutPostResponse200 = {
  data: CreateCheckoutSessionCheckoutPost200
  status: 200
}

export type createCheckoutSessionCheckoutPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createCheckoutSessionCheckoutPostResponseSuccess = (createCheckoutSessionCheckoutPostResponse200) & {
  headers: Headers;
};
export type createCheckoutSessionCheckoutPostResponseError = (createCheckoutSessionCheckoutPostResponse422) & {
  headers: Headers;
};

export type createCheckoutSessionCheckoutPostResponse = (createCheckoutSessionCheckoutPostResponseSuccess | createCheckoutSessionCheckoutPostResponseError)

export const getCreateCheckoutSessionCheckoutPostUrl = () => {




  return `https://subscribe-staging.api.powertrip.earth/checkout`
}

/**
 * @summary Create Checkout Session
 */
export const createCheckoutSessionCheckoutPost = async ( options?: RequestInit): Promise<createCheckoutSessionCheckoutPostResponse> => {

  const res = await fetch(getCreateCheckoutSessionCheckoutPostUrl(),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createCheckoutSessionCheckoutPostResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createCheckoutSessionCheckoutPostResponse
}


